import { ADD_QTY, ADD_TO_CART, EMPTY_CART, REMOVE_FROM_CART, SUB_QTY } from "../actions/types";

const initialState = {
    qr_list: localStorage.getItem("cart") != null ? JSON.parse(localStorage.getItem('cart')) : [],
};
let cart;
const order_qr_cartReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_TO_CART:
            cart = [...state.qr_list, action.payload]
            localStorage.setItem("cart", JSON.stringify(cart))
            return {
                ...state,
                qr_list: cart
            };
        case REMOVE_FROM_CART:
            cart = [...state.qr_list.filter(qr => qr.memoirID !== action.payload)]
            localStorage.setItem("cart", JSON.stringify(cart))
            return {
                ...state,
                qr_list: cart
            };

        case ADD_QTY:
            return {
                ...state,
                qr_list: state.qr_list.map((qr) =>
                    qr.memoirID === action.payload
                        ? { ...qr, qty: qr.qty + 1 }
                        : qr
                ),
            };
        case SUB_QTY:
            return {
                ...state,
                qr_list: state.qr_list.map((qr) =>
                    qr.memoirID === action.payload
                        ? {
                            ...qr,
                            qty: qr.qty !== 1 ? qr.qty - 1 : 1,
                        }
                        : qr
                ),
            };

        case EMPTY_CART:
            return {
                ...state,
                qr_list: []
            }
        default:
            return state;
    }
}

export default order_qr_cartReducer